import { motion } from 'framer-motion';
import { Brain, ShieldCheck, ArrowRight } from 'lucide-react';

export default function DashboardMonitoring({ data, navigate }) {
  return (
    <>
      {/* AI Describes You Card */}
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.085 }} className="mb-4">
        <AIDescribesYouCard scanResults={data} navigate={navigate} />
      </motion.div>

      {/* AI Said WHAT? - Accuracy Check CTA */}
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.09 }} className="mb-4">
        <button
          onClick={() => navigate('/accuracy')}
          className="w-full p-5 rounded-sm flex items-center gap-4 transition-colors hover:bg-[#EDE8DF] group text-left"
          style={{ border: '1px solid #D4C9B8' }}
          data-testid="accuracy-check-btn"
        >
          <div className="w-12 h-12 rounded-none flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(212,68,68,0.06)' }}>
            <ShieldCheck size={22} strokeWidth={1.5} style={{ color: '#D44' }} />
          </div>
          <div className="flex-1 min-w-0">
            <span className="text-[15px] font-medium block" style={{ color: '#3C3226' }}>AI Said WHAT?</span>
            <span className="text-[12px]" style={{ color: '#8C7E6E' }}>Check what AI engines claim about you — and what they get wrong</span>
          </div>
          <ArrowRight size={16} className="flex-shrink-0" style={{ color: '#8C7E6E' }} />
        </button>
      </motion.div>

      {/* AI Insights CTA */}
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.095 }} className="mb-4">
        <button
          onClick={() => navigate('/insights')}
          className="w-full p-4 rounded-sm flex items-center gap-3 transition-colors hover:bg-[#EDE8DF] text-left group"
          style={{ border: '1px solid #D4C9B8' }}
          data-testid="ai-insights-btn"
        >
          <div className="w-10 h-10 rounded-none flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(29,107,79,0.06)' }}>
            <Brain size={18} strokeWidth={1.5} style={{ color: '#1D6B4F' }} />
          </div>
          <div className="flex-1 min-w-0">
            <span className="text-[13px] font-medium block" style={{ color: '#3C3226' }}>AI Insights</span>
            <span className="text-[12px]" style={{ color: '#8C7E6E' }}>Sentiment, AI crawlers, and LLMs.txt</span>
          </div>
          <ArrowRight size={16} className="flex-shrink-0" style={{ color: '#8C7E6E' }} />
        </button>
      </motion.div>
    </>
  );
}

function AIDescribesYouCard({ scanResults, navigate }) {
  const narratives = scanResults?.ai_narratives || scanResults?.results?.ai_narratives || [];
  const mentions = scanResults?.results?.ai_mentions || [];

  const quotes = [];
  if (narratives.length > 0) {
    narratives.forEach(n => {
      if (n.narrative || n.description) {
        quotes.push({ engine: n.engine || 'AI', text: n.narrative || n.description });
      }
    });
  }
  if (mentions.length > 0 && quotes.length === 0) {
    mentions.forEach(m => {
      if (m.context || m.snippet) {
        quotes.push({ engine: m.engine || 'AI', text: m.context || m.snippet });
      }
    });
  }

  if (quotes.length === 0) {
    quotes.push(
      { engine: 'ChatGPT', text: 'Start monitoring to see how AI engines describe your business.' },
    );
  }

  return (
    <div className="p-5 rounded-sm" style={{ backgroundColor: '#2C2520', border: '1px solid #4A3F36' }} data-testid="ai-describes-you-card">
      <div className="flex items-center justify-between mb-4">
        <p className="text-[11px] font-medium uppercase tracking-widest" style={{ color: '#8C7E6E' }}>How AI Describes You</p>
        <button onClick={() => navigate('/accuracy')} className="text-[11px] uppercase tracking-widest transition-colors" style={{ color: '#B8985A' }}>View all</button>
      </div>
      <div className="space-y-3">
        {quotes.slice(0, 3).map((q, i) => (
          <div key={i} className="flex gap-3">
            <span className="text-[10px] uppercase tracking-wider flex-shrink-0 mt-0.5" style={{ color: '#8C7E6E', minWidth: '60px' }}>{q.engine}</span>
            <p className="text-[13px] italic" style={{ color: '#F0EBE3', lineHeight: 1.5 }}>"{q.text}"</p>
          </div>
        ))}
      </div>
    </div>
  );
}
